import { AsyncPipe, NgForOf } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { Store } from '@ngrx/store';
import { TuiDestroyService } from '@taiga-ui/cdk';
import { selectCurrentLocation } from '@us/web/position/data-access';
import { Shop } from '@us/web/shared/data-access';
import { RouterUtil } from '@us/web/shared/utils';
import { ShopsActions, selectShops } from '@us/web/shops/data-access';
import { Observable, distinctUntilChanged, takeUntil, tap } from 'rxjs';
import { ShopCardComponent } from '../shop-card/shop-card.component';

@Component({
    selector: 'us-shops',
    standalone: true,
    imports: [TranslocoModule, NgForOf, AsyncPipe, ShopCardComponent],
    providers: [TuiDestroyService],
    templateUrl: './shops.component.html',
    styleUrls: ['./shops.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShopsComponent implements AfterViewInit {
    private readonly store = inject(Store);
    private readonly destroy$ = inject(TuiDestroyService, { self: true });
    readonly shops$: Observable<Shop[]> = this.store.select(selectShops);

    readonly RouterUtil = RouterUtil;

    ngAfterViewInit() {
        this.store
            .select(selectCurrentLocation)
            .pipe(
                takeUntil(this.destroy$),
                // startWith(undefined),
                distinctUntilChanged(),
                tap(location => {
                    this.store.dispatch(ShopsActions.loadShops(location || {}));
                })
            )
            .subscribe();
    }
}
